const normalize = (value) =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
const identity = (row) =>
  row.resolvedGroup
    ? `group:${row.resolvedGroup}`
    : row.offer.siret
      ? `siret:${row.offer.siret}`
      : `name:${[normalize(row.offer.company), normalize(row.offer.city), normalize(row.offer.address), row.offer.postCode || ""].join(":")}`;
export function groupProspectRows(rows = []) {
  const active = rows.filter((row) => row.state !== "ignored"),
    aliases = new Map();
  for (const row of active) {
    const id = row.result?.clientId || row.match?.clientId;
    if (!id) continue;
    const key = identity(row);
    if (!aliases.has(key)) aliases.set(key, new Set());
    aliases.get(key).add(id);
  }
  const groups = new Map();
  for (const row of active) {
    const key = identity(row),
      ids = aliases.get(key);
    const clientId =
      row.result?.clientId ||
      row.match?.clientId ||
      (ids?.size === 1 ? [...ids][0] : null);
    const groupKey = clientId ? `client:${clientId}` : key;
    if (!groups.has(groupKey)) groups.set(groupKey, []);
    groups.get(groupKey).push(row);
  }
  return [...groups.values()];
}
